import {Lang, supportedLangs, useCompetitionImamrezaContext} from '@context/CompetitionImamrezaContext';
import {useScopedTranslation} from '@hooks/useScopedTranslation';
import scopedI18n from '@locale/scoped-i18n';
import {Box, Button, ButtonProps, styled} from '@mui/material';
import {getSafeLangImage} from '@utils';
import {saveLang} from '@utils/langStorage';
import React, {useEffect} from 'react';
import ar from './assets/images/m0/ar.webp';
import bg from './assets/images/m0/bg.webp';
import boy from './assets/images/m0/boy.webp';
import en from './assets/images/m0/en.webp';
import fa from './assets/images/m0/fa.webp';
import start_ar from './assets/images/m0/start-ar.webp';
import start_en from './assets/images/m0/start-en.webp';
import start_fa from './assets/images/m0/start-fa.webp';
import title_ar from './assets/images/m0/title-ar.webp';
import title_en from './assets/images/m0/title-en.webp';
import title_fa from './assets/images/m0/title-fa.webp';


const langImage: Record<Lang, string> = {
	en,
	fa,
	ar
};

const titleImage: Record<Lang, string> = {
	en: title_en,
	fa: title_fa,
	ar: title_ar
};

const startImage: Record<Lang, string> = {
	en: start_en,
	fa: start_fa,
	ar: start_ar
};

interface MainPageProps {
	lang?: 'en' | 'fa' | 'ar';
	setLang?: (lang: 'en' | 'fa' | 'ar') => void;
}

const ColorButton = styled(Button)<ButtonProps>(({theme}) => ({
	color: theme.palette.getContrastText('rgb(146, 64, 14)'),
	backgroundColor: 'rgb(146, 64, 14)',
	'&:hover': {
		backgroundColor: 'rgb(146, 64, 14)'
	}
}));
export const MainPage = (props: MainPageProps) => {
	const {lang: deflang, setLang} = props;
	const {t, i18n} = useScopedTranslation();
	useEffect(() => {
		localStorage.setItem('imamreza_competition_done', 'false');
	}, []);
	const {
		phone,
		setPhone,
		mission,
		setMission
	} = useCompetitionImamrezaContext();
	return (
		<Box
			className="w-full flex flex-col h-full justify-start overflow-y-auto relative"
			sx={{
				backgroundImage: `url(${bg})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover'
			}}
		>
			<div className="w-10/12 mx-auto pb-[40vh]">
				{
					props.lang && (
						<div className={'w-full h-36 my-10'}>
							<img src={getSafeLangImage(titleImage, props.lang)} alt={'title'}/>
						</div>
					)
				}
				<div className="flex flex-row w-full mx-auto">
					{
						supportedLangs.map((lang) => {
							const imageSrc = langImage[lang];
							if (!imageSrc) return null;
							
							return (
								<div
									key={lang}
									className={`${deflang === lang ? 'opacity-100' : 'opacity-50 cursor-pointer'}`}
									onClick={() => {
										if (setLang && deflang !== lang) {
											scopedI18n.changeLanguage(lang);
											setLang(lang);
											saveLang(lang);
										}
									}}
								>
									<img src={imageSrc} alt={lang} className="w-5/6"/>
								</div>
							);
						})}
				</div>
				{
					props.lang && (
						<div className="w-10/12 mx-auto justify-center items-center flex flex-row content-center">
							<div
								className={'h-fit text-white mx-auto my-5 cursor-pointer'}>
								<img src={getSafeLangImage(startImage, props.lang)} alt="start" className={'w-5/12 mx-auto'}
								     onClick={() => setMission(1)}/>
								{/*<ColorButton variant="text" className="rounded-2xl" onClick={() => setMission(1)}>*/}
								{/*	{t('go')}*/}
								{/*</ColorButton>*/}
							</div>
						</div>
					)
				}
				<div className="w-full flex justify-center mt-auto absolute bottom-0 left-0">
					<img
						src={boy}
						alt="boy"
						className="w-auto h-[calc(100vh-400px)] object-contain"
					/>
				</div>
			</div>
		</Box>
	);
};
